import remoteConfigDefaults from 'assets/firebase/remote_config_defaults.json'
import firebase from 'firebase/compat/app'
import 'firebase/compat/auth'
import 'firebase/compat/remote-config'
import dayjs from 'dayjs'
import { useEffect } from 'react'
import { useShallow } from 'zustand/shallow'
import { useZustandGlobalLocalStore } from 'zustandGlobalLocalStore'
import { useZustandStore } from 'zustandGlobalStore'

export const useInitFirebase = (): void => {
  const { firebaseConfig, cohort } = useZustandStore(
    useShallow((state) => ({
      firebaseConfig: state.lead?.config?.app?.firebaseConfig,
      cohort: state.lead?.cohort || state.initialCohort,
    })),
  )

  useEffect(() => {
    if (!firebaseConfig || firebase.apps.length || !cohort) return

    const initializeAndActivateRemoteConfig = async () => {
      firebase.initializeApp(firebaseConfig)
      firebase.auth().signOut()

      const remoteConfig = firebase.remoteConfig()
      remoteConfig.defaultConfig = remoteConfigDefaults

      try {
        await remoteConfig.fetchAndActivate()

        useZustandStore.setState({ isFrcSettled: true })

        const { frcSettledDate } = useZustandGlobalLocalStore.getState()
        if (!frcSettledDate) {
          useZustandGlobalLocalStore.setState({
            frcSettledDate: dayjs().format('DD/MM/YYYY'),
          })
        }
      } catch (err) {
        console.warn(err)
      } finally {
        useZustandStore.setState({
          firebaseRemoteConfig: remoteConfig,
          isFirebaseRemoteConfigReady: true,
        })
      }
    }

    initializeAndActivateRemoteConfig()
  }, [firebaseConfig, cohort])
}
